"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawableTag = exports.MarkerType = void 0;
var MarkerType;
(function (MarkerType) {
    MarkerType[MarkerType["NONE"] = 0] = "NONE";
    MarkerType[MarkerType["BASE"] = 1] = "BASE";
    MarkerType[MarkerType["BASE_OFFSET"] = 2] = "BASE_OFFSET";
})(MarkerType || (exports.MarkerType = MarkerType = {}));
var DrawableTag;
(function (DrawableTag) {
    DrawableTag["MARKER"] = "marker";
    DrawableTag["LABEL"] = "label";
    DrawableTag["OFFSET"] = "offset";
    DrawableTag["LINE"] = "line";
    DrawableTag["MASK"] = "mask";
    DrawableTag["VERTICAL_SEPARATION"] = "vertical-separation";
})(DrawableTag || (exports.DrawableTag = DrawableTag = {}));
//# sourceMappingURL=collection.drawable.js.map